export default __webpack_public_path__ + "static/media/whisk.7a6fc50b.gif";